export default {
  Status:{
    Draft:1, //Nháp
    InProgess:4, //Chưa hoàn thành
    Completed:2, //Đã hoàn thành
    CompletedLate:3, // Hòa thành trễ hạn
    InProgessLate:5, //Chưa hoàn thành trễ hạn
    InCompleted:6 //Không hoàn thành
  },

  CustomStatus:{
       
    /// <summary>
    /// Hoàn thành đúng hạn
    /// </summary>
    SuccessInTime : 1,

    /// <summary>
    /// Hoàn thành trễ hạn
    /// </summary>
    SuccessOutTime : 2,

    /// <summary>
    /// Chưa hoàn thành trong hạn
    /// </summary>
    InProcessInTime : 3,

    /// <summary>
    /// Chưa Hoàn thành trễ hạn
    /// </summary>
    InProcessOutTime : 4,

    /// <summary>
    /// Ko hoàn thành
    /// </summary>
    NotSuccess : 5,

    /// <summary>
    /// Chưa hoàn thành
    /// </summary>
    InProcess : 6,

    /// <summary>
    /// Hoàn thành
    /// </summary>
    Success : 7,
  },

  // Enum các danh sách công việc
  TaskListMode: {
    listNeedToDo: 1,
    listAllTask: 2,
    listAssignedByMe: 3,
    listDone: 4,
    listNeedToApprove: 5,
    listInvolve: 6,
    listDraft: 7,
    listReportOperateByMe: 8,
    listReportMyOrg: 9,
    listReportPersonality: 10,
    listApproveUpdateDeadline: 11
  },
  //Enum Role
  RoleTypeName:{
    Assigner: 'Người giao việc',
    Executor: 'Người chủ trì',
    Combination:'Người phối hợp',
    PeopleInvolved:'Người liên quan'
  },
  RoleType:{
    Assigner: 1,
    Executor: 2,
    Combination:3,
    PeopleInvolved:4
  },
  StatusApprovalMission:{
    /**
     * Khởi tạo
     */
    None: 0,
    /**
     * Đang xử lý
     */
    Process: 1,
    /// <summary>
    /// Đã phê duyệt
    /// </summary>
    Success : 2,
    /**
     * Đã trả lại
     */
    Reject:3,
  }
}